import React from 'react';
import classNames from 'classnames/bind';
import styles from './PageTitle.module.scss';

const cx = classNames.bind(styles);
function UserPageTitle(props) {
  const { underlinedText, otherText, noUnderline, className, fontSize } = props;
  return (
    <h1 className={cx('UserPageTitle', className)}>
      <span className={cx('underlined', { noUnderline })} style={{ fontSize }}>
        {underlinedText}
      </span>
      <span className={cx('other')} dangerouslySetInnerHTML={{ __html: otherText }} />
    </h1>
  );
}

export default UserPageTitle;
